export const self_order_counter_url: string = "self_order_counter";